export default "__VITE_ASSET__Cw22YoT8__"